import CookiesJS from 'cookies-js';

export function initKitchenwares($, apiClient) {
    $('form.kitchenware-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const kitchenware = {
                title: $('#title').val(),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/kitchenware', kitchenware, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/kitchenware/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/kitchenware', _id, kitchenware, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
